/// <reference path="../../_ext/Editors/BOMEditorDialog.ts" />

namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocationItemsBOMDialog extends _Ext.BOMEditorDialog<StockAllocationItemsBOMRow> { 
        protected getLocalTextPrefix() { return StockAllocationItemsBOMRow.localTextPrefix; } 
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        } 
    }
}